import { withResetState } from "store/hocs";

import { agentSetupConstants } from "./agentSetup.constants";

const initialState = {
	error: null,
	agents: [],
	agentCompaniesList: [],
	editAgentDocuments: [],
	whoCanTheySee: [],
	whoCanSeeThem: [],
	loading: false,
	agentFormDataLoading: false,
};

function agentSetup(state = initialState, action) {
	switch (action.type) {
		case agentSetupConstants.GET_AGENT_COMPANIES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				agentCompaniesList: action.agentCompaniesList,
			};
		case agentSetupConstants.GET_AGENT_COMPANIES_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case agentSetupConstants.GET_AGENT_FORM_DATA_REQUEST:
			return {
				...state,
				agentFormDataLoading: true,
			};
		case agentSetupConstants.GET_AGENT_FORM_DATA_SUCCESS:
			return {
				...state,
				agentFormDataLoading: false,
				error: null,
				agentFormData: action.agentFormData,
			};
		case agentSetupConstants.GET_AGENT_FORM_DATA_ERROR:
			return {
				...state,
				agentFormDataLoading: false,
				error: action.error,
			};
		case agentSetupConstants.GET_AGENT_SETUP_DOCUMENTS_SUCCESS:
			return {
				...state,
				editAgentDocuments: action.editAgentDocuments,
			};
		case agentSetupConstants.GET_AGENT_SETUP_DOCUMENTS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentSetupConstants.GET_WHO_CAN_THEY_SEE_SUCCESS:
			return {
				...state,
				whoCanTheySee: action.whoCanTheySee,
			};
		case agentSetupConstants.GET_WHO_CAN_THEY_SEE_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentSetupConstants.GET_WHO_CAN_SEE_THEM_SUCCESS:
			return {
				...state,
				whoCanSeeThem: action.whoCanSeeThem,
			};
		case agentSetupConstants.GET_WHO_CAN_SEE_THEM_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state;
	}
}

export default withResetState({ initialState })(agentSetup);
